<template>
  <v-container fluid>
    <!-- Start Filter -->
    <template v-if="viewPage !== 'number'">
      <v-layout wrap>
        <v-flex xs12 sm6>
          <v-btn
            depressed
            :outline="channelFilter != 'all'"
            :color="channelFilter == 'all' ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="channelFilter = 'all'"
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="channelFilter != 'facebook'"
            :color="channelFilter == 'facebook' ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="channelFilter = 'facebook'"
          >
            <em class="fab fa-facebook-square mr-1" />
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="channelFilter != 'line'"
            :color="channelFilter == 'line' ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="channelFilter = 'line'"
          >
            <em class="fab fa-line mr-1" />
            {{ $t('Line') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-sm-right">
          <template v-if="loading">
            <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
          </template>
          <template v-else>
            <exportxlsx :promised-value="getXlsxData"></exportxlsx>
          </template>
        </v-flex>
      </v-layout>
      <!-- Date Filter -->
      <date-filter
        v-model="selectedDate"
        :default-filter="'last_7_days'"
        @changeDate="onChangeDate"
      ></date-filter>
      <!-- End Date Filter -->
    </template>

    <v-layout wrap class="pt-4">
      <v-flex xs12 sm6>
        <v-btn
          depressed
          :outline="viewPage != 'info'"
          :color="viewPage == 'info' ? 'primary' : 'grey'"
          class="ma-0 mr-1 mb-1"
          @click="onViewPage('info')"
        >
          {{ $t('Warranty Info') }}
        </v-btn>
        <v-btn
          depressed
          :outline="viewPage != 'number'"
          :color="viewPage == 'number' ? 'primary' : 'grey'"
          class="ma-0 mr-1 mb-1"
          @click="onViewPage('number')"
        >
          {{ $t('Warranty Number') }}
        </v-btn>
      </v-flex>
      <v-flex v-if="viewPage !== 'number'" xs12 sm6 class="text-xs-right text-sm-right">
        <v-btn depressed outline color="primary" class="ma-0 mr-1 mb-1" @click="showsearch = true">
          <v-icon>search</v-icon>&nbsp;{{ $t('Advanced Search') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <template v-if="viewPage !== 'number'">
      <!-- Start Content -->
      <h3 class="headline">{{ $t('Warranty Info') }}</h3>
      <v-data-table
        :headers="headers"
        :items="dataWarranty"
        :loading="loading"
        hide-actions
        :pagination.sync="pagination"
        class="elevation-1 mt-4"
        :search="search"
      >
        <!-- hide-actions -->
        <template #items="props">
          <tr>
            <td>{{ getDateFormatted(props.item.timestamp) }}</td>
            <td class="text-sm-center">
              {{
                props.item.receipt_timestamp ? getDateFormatted(props.item.receipt_timestamp) : '-'
              }}
            </td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.lineid }}</td>
            <td>{{ props.item.phone_number }}</td>
            <td class="text-sm-center">
              {{ props.item.shop_via ? props.item.shop_via : '-' }}
              <div v-if="props.item.shop_via == 'Other'">({{ props.item.other_branch }})</div>
            </td>
            <td class="text-sm-center">
              <template v-if="props.item.total_purchase > 0">
                {{ props.item.total_purchase | numberFormat }}
              </template>
              <template v-else>-</template>
            </td>
            <td class="text-center">
              <template v-if="props.item.shop_via">
                <a href="javascript:void(0);" @click="showImage(props.item.receipt)">
                  <em class="fas fa-file-invoice fa-2x" />
                </a>
              </template>
              <template v-else>-</template>
            </td>
            <td>
              <div class="mt-2">
                <v-select
                  v-model="props.item.status"
                  :items="allStatus"
                  label="Status"
                  single-line
                  outline
                  @change="onChangeStatus(props.item.id, $event)"
                ></v-select>
              </div>
            </td>
            <td class="text-center">
              <a href="javascript:void(0);" @click="showWarrantyDetails(props.item.id)">
                <span><em class="fas fa-align-left fa-2x" /></span>
              </a>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="mt-2">
        <v-pagination
          v-model="pageNumber"
          :total-visible="6"
          :length="pagelength"
          @input="changePage"
        ></v-pagination>
      </div>

      <!-- Modal Search Info -->
      <v-dialog v-model="showsearch" width="700px" persistent>
        <v-card>
          <div style="float: right">
            <v-btn icon @click="showsearch = false"><v-icon>close</v-icon></v-btn>
          </div>
          <div class="pa-2 pt-4 pb-3">
            <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
            <!-- Search info -->
            <div>
              <v-layout class="pa-0 ma-0" wrap row>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('ชื่อ-สกุล') }}</label>
                  <input v-model="filter.name" class="form-control" type="text" />
                </v-flex>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('LINE') }}</label>
                  <input v-model="filter.lineid" class="form-control" type="text" />
                </v-flex>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('เบอร์โทรศัพท์') }}</label>
                  <input v-model="filter.phone_number" class="form-control" type="text" />
                </v-flex>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('ช็อป/ออนไลน์') }}</label>
                  <Multiselect
                    v-model="filter.shop_via"
                    :options="allBranchList"
                    :max-height="200"
                    open-direction="above"
                    @input="$emit('change', $event)"
                  ></Multiselect>
                </v-flex>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('สถานะ') }}</label>
                  <Multiselect
                    v-model="filter.status"
                    :options="status"
                    label="text"
                    open-direction="above"
                    @input="$emit('change', $event)"
                  ></Multiselect>
                </v-flex>
              </v-layout>
            </div>
            <div class="text-xs-center">
              <v-btn outline color="grey" @click="clearsearch">Clear</v-btn>
              <v-btn color="primary" @click="onsearch">Search</v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <!-- Modal Warranty Details -->
      <v-dialog v-model="warrantyDetailsModal" persistent width="950px">
        <v-card v-if="warrantyDetailsModal">
          <LamyWarrantyDetails :id="id" @close="warrantyDetailsModal = false"></LamyWarrantyDetails>
        </v-card>
      </v-dialog>

      <!-- Modal view receipt -->
      <v-dialog v-model="receiptModal" persistent width="600px">
        <v-card>
          <div class="text-xs-right">
            <v-btn flat fab small class="extra-small" @click="receiptModal = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <template v-if="loadingImage">
            <div class="text-left">
              <scale-loader
                :color="$vuetify.theme.primary"
                height="20px"
                width="5px"
                style="max-width: 50px"
              ></scale-loader>
            </div>
          </template>
          <template v-else>
            <div class="text-center">
              <img :src="imageUrl" width="500px" height="100%" />
            </div>
          </template>
        </v-card>
      </v-dialog>
    </template>
    <!-- viewPage == 'Number' -->
    <template v-else>
      <LamyWarrantyNumber></LamyWarrantyNumber>
    </template>
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import LamyWarrantyDetails from './LamyWarrantyDetails.vue'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import DateFilter from '../../DateFilter'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import LamyWarrantyNumber from './LamyWarrantyNumber.vue'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    LamyWarrantyDetails,
    ScaleLoader,
    DateFilter,
    exportxlsx,
    Multiselect,
    LamyWarrantyNumber
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: 'วันที่สะสมยอด', value: 'timestamp', width: '5%', sortable: false },
        { text: 'วันที่ซื้อสินค้า', value: 'timestamp', width: '5%', sortable: false },
        { text: 'ชื่อลูกค้า', value: 'name', width: '2%', sortable: false },
        { text: 'LINE', value: 'name', width: '2%', sortable: false },
        { text: 'เบอร์ติดต่อ', value: 'phoneNumber', width: '2%', sortable: false },
        { text: 'ช็อป / ออนไลน์', value: 'shop', width: '2%', sortable: false },
        { text: 'ยอดรวมสินค้า', value: 'shop', width: '2%', sortable: false },
        { text: 'อัปโหลดสลิป', value: 'uploadedSlip', width: '2%', sortable: false },
        { text: 'สถานะ', value: 'status', width: '2%', sortable: false },
        { text: '', value: '', width: '2%', sortable: false }
      ],
      dataWarranty: [],
      loading: false,
      search: '',
      channelFilter: 'all',
      filter: {
        name: '',
        phone_number: '',
        shop_via: '',
        status: '',
        lineid: ''
      },
      warrantyDetailsModal: false,
      receiptModal: false,
      id: null,
      imageUrl: null,
      loadingImage: false,
      allStatus: ['pending', 'approve', 'reject'],
      importloading: false,
      viewPage: 'info',
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      isExport: false,
      showsearch: false,
      allBranchList: [
        'B2S Central Bangna',
        'B2S Central Chaengwattana',
        'B2S Central Chidlom',
        'B2S Central Ladprao',
        'B2S Central Pattaya',
        'B2S Central Phuket',
        'B2S Central Pinklao',
        'B2S Central Plaza Chiangmai',
        'B2S Central Plaza East Ville',
        'B2S Central Plaza Rama 9',
        'B2S Central Plaza Salaya',
        'B2S Central Plaza Westgate',
        'B2S Central Rama 2',
        'B2S Central Rama 3',
        'B2S Central Rungsit',
        'B2S Central Silom Complex',
        'B2S Central Udonthani',
        'B2S Central World Plaza',
        'B2S CPN Ayutthaya',
        'B2S CPN Chanthaburi',
        'B2S CPN Hadyai',
        'B2S CPN Mahachai',
        'B2S CPN Phitsanulok',
        'B2S CPN Rayong',
        'B2S CPN Samui',
        'B2S CPN Sriracha',
        'B2S Mega Bangna',
        'B2S Online',
        'B2S Rangsit (RBS)',
        'B2S Robinson Bangrak',
        'B2S Robinson Chiangrai',
        'B2S Robinson Chonburi',
        'B2S Robinson Khonkaen',
        'B2S Robinson Rungsit',
        'B2S Robinson Samutprakan',
        'B2S Robinson Saraburi',
        'B2S Robinson Srinakarin',
        'B2S Robinson Srisaman',
        'B2S Robinson Suphanburi',
        'B2S Robinson Suratthani',
        'B2S Robinson Ubonratchathani 2',
        'B2S Crystal Park Ramintha',
        'B2S The Promenade',
        'B2S Seacon Srinakarin',
        'B2S Seacon Bangkae',
        'B2S CPN Korat',
        'B2S CPN Nakhonpathom',
        'B2S CPN Nakhon Sawan',
        'B2S CPN Pitsanuloke',
        'B2S CPN Rangsit',
        'B2S CPN Westville',
        'Officemate Online',
        'Central Bangna',
        'Central Chidlom',
        'Central Lardprao',
        'Central Pinklao',
        'Emporium',
        'e-Shop (www.lamy.co.th)',
        'LAMY Pop-Up Central World',
        'LAMY Pop-Up Mega Bangna',
        'Lamy Concept Store One Bangkok',
        // "Loft ICON SIAM",
        // "Loft Online",
        // "Loft Siam Discovery",
        'Siam Discovery',
        'Siam Paragon',
        'The Mall Bangkae',
        'The Mall Bangkapi',
        'The Mall Ngamwongwan',
        'The Mall Ratchasima',
        'The Mall Thapra',
        'Other'
      ],
      status: [
        { text: 'Pending', value: 'pending' },
        { text: 'Approve', value: 'approve' },
        { text: 'Reject', value: 'reject' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    pageid() {
      return this.selectedBot.pageid
    }
  },
  mounted() {
    var vm = this
    vm.getWarranty()
  },

  methods: {
    getWarranty() {
      return new Promise((resolve) => {
        var vm = this
        var limit = 0

        if (vm.isExport) {
          limit = vm.total
        } else {
          limit = vm.limit
        }

        var data = {
          pageid: vm.pageid, // required
          limit: limit, // required
          offset: vm.offset, // required
          name: vm.filter.name,
          lineid: vm.filter.lineid,
          phone_number: vm.filter.phone_number,
          shop_via: vm.filter.shop_via,
          start_date: vm.selectedDate.start,
          end_date: vm.selectedDate.end,
          status: vm.filter.status.value // approve, reject
        }
        vm.loading = true
        api.getLamyWarranty(data, (err, response) => {
          if (response.responsecode == 200) {
            vm.dataWarranty = response.data
            vm.total = response.total
            vm.loading = false

            resolve(response.data)
          } else {
            console.log(err)
            return
          }
        })
      })
    },
    getXlsxData() {
      return new Promise(async (resolve) => {
        this.isExport = true
        var data = await this.getWarranty()

        resolve(
          data.map((el) => {
            return {
              วันที่สะสมยอด: el.timestamp ? moment(el.timestamp).format('DD/MM/YYYY') : '',
              วันที่ซื้อสินค้า: el.receipt_timestamp
                ? moment(el.receipt_timestamp).format('DD/MM/YYYY')
                : '',
              ชื่อลูกค้า: el.name,
              LINE: el.lineid,
              เบอร์ติดต่อ: el.phone_number,
              ช็อป: el.shop_via ? el.shop_via : '',
              ยอดรวมสินค้า: el.total_purchase ? el.total_purchase : '',
              สถานะ: el.status
            }
          })
        )

        this.isExport = false
      })
    },
    getDateFormatted(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    showWarrantyDetails(id) {
      var vm = this
      vm.id = id
      vm.warrantyDetailsModal = true
    },
    showImage(url) {
      var vm = this
      this.loadingImage = true
      vm.imageUrl = url
      this.loadingImage = false
      vm.receiptModal = true
    },
    onChangeStatus(id, status) {
      this.id = id
      this.status = status
      this.updateStatus()
    },
    updateStatus() {
      var vm = this
      let data = {
        pageid: vm.pageid,
        id: vm.id,
        status: vm.status
      }
      api.putLamyWarrantyEdit(data, function (error, response) {
        if (response.responsecode == 200) {
          vm.$swal.fire({ text: 'อัพเดทสถานะเรียบร้อย' })
          vm.getWarranty()
        } else if (response.responsecode == 204) {
          vm.$swal.fire({
            text: 'อัพเดทสถานะไม่สำเร็จ เนื่องจากรายการสั่งซื้อนี้ สะสมยอดครบในการเลื่อนระดับสมาชิก'
          })
        } else {
          console.error(error)
          return
        }
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getWarranty()
      }
    },
    onChangeDate() {
      this.getWarranty()
    },
    onsearch() {
      this.limit = 10
      this.offset = 0
      this.getWarranty()
      this.showsearch = false
    },
    clearsearch() {
      ;(this.filter = {
        name: '',
        phone_number: '',
        shop_via: '',
        status: '',
        lineid: ''
      }),
        this.onsearch()
    },
    onViewPage(page) {
      this.viewPage = page
      ;(this.selectedDate = {
        start: moment().format('YYYY-MM-DD 00:00'),
        end: moment().format('YYYY-MM-DD 23:59')
      }),
        (this.showsearchNumber = false)
      this.clearsearch()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/lamy/LamyWarranty.vue